const targetElement = $("ul.information-list");

// 重複実行を避けるためのフラグ。イベント待機時にtrue
let lazyLoadFlag = true;

// LazyLoad用イベント
$(window).on("load", function () {
    // LazyLoad後に画面更新・別画面から戻った場合に強制スクロールしてしまうためスクロール履歴削除
    history.scrollRestoration = "manual";
    $(window).scrollTop(0);
});

/**
 * lazyLoad（ページ最下までスクロールすると続きのデータを読み込む）
 */
$(window).on('lazyLoad', function(){
    // ターゲット要素の底までスクロールしたか判定
    if ($(this).scrollTop() + $(this).height() > targetElement.offset().top + targetElement.height()) {
        if(lazyLoadFlag){
            lazyLoadFlag = false;
            lazyLoad();
        }
    }
})

// lazyLoadイベント発火用のスクロールイベント
$(window).scroll(function(){
    $(window).trigger('lazyLoad');
});

function lazyLoad(){
    const loadUrl = $("#loadUrl").val() ? String($("#loadUrl").val()) : null;

    $.ajax({
        type: "GET",
        url: loadUrl,
        contentType: "application/json; charset=utf-8",
        data: {
            contentNo: targetElement.children("li").length
        },
        dataType: "html",
        success: function (res) {
            // html反映
            targetElement.append(res);

            // 対象のコンテンツを全てレンダリングしたらスクロールイベント削除
            const isLoadEnd = $("#isLoadEnd").val() === "true" ? true : false;
            if (isLoadEnd) {
                $(window).off("lazyLoad");
            }
            lazyLoadFlag = true;
        },
        error: function (req, status, error) {
            // TODO: エラーメッセージは一旦決め打ちで入力
            const errorShow = `<p class="not-found-content__text black align-left">An error occurred in the search process.</p>`;
            targetElement.append(errorShow);
            $(window).off("lazyLoad");
        },
    });
}
